export const filters = {
  data(){
    return {
      nameTooltip: false
    }
  },
  methods: {
    replacer(str) {
      let ru = {
        'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
        'е': 'e', 'ё': 'e', 'ж': 'j', 'з': 'z', 'и': 'i',
        'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
        'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
        'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh',
        'щ': 'shch', 'ы': 'y', 'э': 'e', 'ю': 'u', 'я': 'ya'
      }, n_str = [];

      str = str.replace(/[ъь]+/g, '').replace(/й/g, 'i').replace(/ /g, '_');

      for ( let i = 0; i < str.length; ++i ) {
        n_str.push(
          ru[ str[i] ]
          || ru[ str[i].toLowerCase() ] == undefined && str[i]
          || ru[ str[i].toLowerCase() ].replace(/^(.)/, function ( match ) { return match.toUpperCase() })
        );
      }

      return n_str.join('');
    },
    trimMonth(val) {
      return val.slice(0,3) + '.'
    },
    trimString(val, length) {
      if (val && val.length > length) {
        return val.slice(0, length) + '...'
      };
      return val
    },
    trimName(string) {
      let length = 80;
      if (window.matchMedia('(max-width: 1750px)').matches) {
        length = 65
      };
      if (window.matchMedia('(max-width: 1650px)').matches) {
        length = 60
      };

      if (window.matchMedia('(max-width: 1580px)').matches) {
        length = 50
      };

      if (window.matchMedia('(max-width: 1460px)').matches) {
        length = 40
      };

      if (window.matchMedia('(max-width: 1320px)').matches) {
        length = 30
      };

      if (window.matchMedia('(max-width: 1210px)').matches) {
        length = 20
      };


      if (string && string.length > length) {
        string = string.slice(0, length) + '...';
        this.nameTooltip = true
      } else {
        this.nameTooltip = false
      }
      return string
    },
    delDouble(arr, property, property2) {
      let a = arr.concat();
      for (let i = 0; i < a.length; ++i) {
        for (let j = i + 1; j < a.length; ++j) {
          if (!property2) {
            if (a[i][property] == a[j][property]) {
              a.splice(j--, 1);
            }
          } else {
            if (a[i][property][property2] == a[j][property][property2]) {
              a.splice(j--, 1);
            }
          }
        }
      };
      return a
    },
    arrDiff(a1,a2) {
      let a = [],diff = [];
      for (let i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
      };
      for (let i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
          delete a[a2[i]]
        } else {
          a[a2[i]] = true
        }
      };

      for (let k in a) {
        diff.push(k)
      };
      return diff
    },
    timestampToData(val) {
      val = Number(val) * 1000;
      let date = new Date(val);
      let day = date.getDate();
      let month = this.trimMonth(this.translateMonth(date.getMonth())).toLowerCase();
      let year = date.getFullYear();
      return `${day} ${month} ${year}`
    },
    timestampToDataMonth(val) {
      val = Number(val) * 1000;
      let date = new Date(val);
      let day = date.getDate();
      let month = this.trimMonth(this.translateMonth(date.getMonth())).toLowerCase();
      return `${day} ${month}`
    },
    timestampToDataWithTime(val) {
      val = Number(val) * 1000;
      let date = new Date(val);
      let day = date.getDate();
      let month = this.trimMonth(this.translateMonth(date.getMonth())).toLowerCase();
      let year = date.getFullYear();
      let hours = date.getHours();
      let min = date.getMinutes();
      let sec = date.getSeconds();
      return `${day} ${month} ${year} ${hours}:${min}:${sec}`
    },
    translateMonth(month) {
      switch (month) {
        case (0): return this.$t('labels.months.jan');
          break;
        case (1): return this.$t('labels.months.feb');
          break;
        case (2): return this.$t('labels.months.Mar');
          break;
        case (3): return this.$t('labels.months.apr');
          break;
        case (4): return this.$t('labels.months.may');
          break;
        case (5): return this.$t('labels.months.jun');
          break;
        case (6): return this.$t('labels.months.jul');
          break;
        case (7): return this.$t('labels.months.aug');
          break;
        case (8): return this.$t('labels.months.sep');
          break;
        case (9): return this.$t('labels.months.oct');
          break;
        case (10): return this.$t('labels.months.nov');
          break;
        case (11): return this.$t('labels.months.dec');
          break;
      }
    }
  },
  destroyed() {
    this.nameTooltip = false
  }
}
